import ObjectCache from './CacheService';
import UserAccount from '../UserAccount';
import DatabaseCollectionApi from '../server/DatabaseCollectionApi';
import DatabaseCollection from '../../models/databasecollection';
import Company from '../Company';

class DatabaseCollectionCache extends ObjectCache {
  api = DatabaseCollectionApi;
  createNew = (title, description, name, database) => new DatabaseCollection(null, UserAccount.account._id, [], [], UserAccount.account._id, title, description, name, database, {}, [], null, null, null, null, null, Company.company && Company.company._id || '');
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new DatabaseCollection(results._id, results.owner, results.users, results.teams, UserAccount.account._id, results.title, results.description, results.name, results.database, results.schema, results.indices, results.createdTime, results.updateTime, results.state, results.shareSetting, results.version, results.company, results.background, results.functions);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}

const singleton = new DatabaseCollectionCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
